import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var smoothScrollElement = function smoothScrollElement(element, targetScrollPosition) {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches || // documentMode is only in IE, which doesn't support element scrollTo https://caniuse.com/?search=scrollto
  // see https://stackoverflow.com/a/37199444 https://chegg.atlassian.net/browse/CUI-750 for more

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  Boolean(window.document.documentMode)) {
    if (targetScrollPosition.left) {
      element.scrollLeft = targetScrollPosition.left;
    }

    if (targetScrollPosition.top) {
      element.scrollTop = targetScrollPosition.top;
    }
  } else {
    element.scrollTo(_objectSpread(_objectSpread({}, targetScrollPosition), {}, {
      // this isn't supported in Safari, but doesn't cause issues being here either
      behavior: 'smooth'
    }));
  }
};

export default smoothScrollElement;